import React from 'react';

import MarkdownText from '../MarkdownText';
import StatsTable from '../StatsTable';

import './SummaryEntry.css';

export default ({ stats, summary }) => (
  <div className="SummaryEntry">
    {summary && (
      <div className="SummaryEntry__summary">
        <MarkdownText text={summary} />
      </div>
    )}

    <p className="SummaryEntry__table-header">By the numbers:</p>

    <div className="SummaryEntry__table">
      <StatsTable
        rows={[
          { name: 'Repos touched', value: stats.numRepos },
          { name: 'Pull requests', value: stats.prs },
          { name: 'Commits', value: stats.commits },
          { name: 'Lines removed', value: stats.deletions },
          { name: 'Lines added', value: stats.additions },
        ]}
      />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/timeline/SummaryEntry.js